import { NotificationType } from '@pages/Notifications/Notifications.utils'

export const notificationToLabel = (notification) => {
  if (notification?.type === NotificationType.Message) {
    return 'New Message'
  }
  if (notification?.type === NotificationType.AppointmentScheduled) {
    return 'New Scheduled Appointment'
  }
  return 'New Notification'
}

export const mapNotification = (notification) => ({
  id: notification.notification_id,
  authorId: notification.author_id,
  read: false,
  type: notification.type,
  properties: {
    id: notification.properties.id,
    patientId: notification.properties.patient_id,
    messageId: notification.properties.message_id,
    patientName: notification.properties.patient_name,
    cboName: notification.properties.cbo_name,
    replyingMessage: notification.properties.replying_message,
    endTimeTz: notification.properties.end_time_tz,
    startTimeTz: notification.properties.start_time_tz,
    appointmentId: notification.properties.appointment_id,
    appointmentType: notification.properties.appointment_type,
    appointmentTime: notification.properties.appointment_time,
    appointmentSchedType: notification.properties.appointment_sched_type,
    scheduleSlotType: notification.properties.schedule_slot_type,
    encounterId: notification.properties.encounter_id,
    encounterDescription: notification.properties.encounter_description,
    report: notification.properties.report,
    taskKind: notification.properties.task_kind,
    taskIdentifier: notification.properties.task_identifier,
    taskId: notification.properties.task_id,
    kind: notification.properties.kind,
    reason: notification.properties.reason,
    description: notification.properties.description,
    resolution: notification.properties.resolution,
    licenseId: notification.properties.license_id,
    state: notification.properties.state,
    type: notification.properties.type,
    licenseNumber: notification.properties.license_number,
    medicaid: notification.properties.medicaid,
    expirationDate: notification.properties.expiration_date,
    text: notification.properties.text,
  },
})
